const {
  GIFTING_TREES,
  JOBS,
  SHOP,
  FAQ,
  INSTAGRAM,
  YOUTUBE,
  LINKEDIN,
  FACEBOOK,
  TREECARD,
  TWITTER,
} = require('../constants/urls');

const { DEFAULT_LOCALE, BLOG_LOCALES } = require('../constants/i18n');

const getBlogURL = (locale) => {
  const domain = BLOG_LOCALES.includes(locale) ? `${locale}.` : '';
  return `https://${domain}blog.ecosia.org`;
};

exports.getBlogURL = getBlogURL;

exports.getFinancialReportURL = (locale) => {
  const domain = BLOG_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  return `https://ecosia.co/finreports${domain}`;
};

exports.getShareMenu = (text) => {
  const baseUrl = encodeURIComponent('https://info.ecosia.org?utm_source=stc');
  return [{
    label: 'Facebook',
    id: 'facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${baseUrl}&t=${text}`,
  }, {
    label: 'Twitter',
    id: 'twitter',
    url: `https://www.twitter.com/share?url=${baseUrl}&text=${text}`,
  }, {
    label: 'Pinterest',
    id: 'pinterest',
    url: `http://pinterest.com/pin/create/link/?url=${baseUrl}`,
  }];
};

exports.getFooterMenu = (locale, settingsLink = false) => {
  const menu = [{
    url: getBlogURL(locale),
    key: 'blog',
  }, {
    url: TREECARD,
    key: 'treecard',
  }, {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  }];
  if (settingsLink) {
    menu.push({
      url: `${process.env.indexpageUrl}settings`,
      key: 'settings',
    });
  }
  menu.push({
    url: FAQ,
    key: 'faq',
  }, {
    url: `${process.env.infoUrl}/about#contact`,
    key: 'feedback',
  }, {
    url: `${process.env.infoUrl}/imprint`,
    key: 'imprint',
  });
  return menu;
};

exports.getSocialMenu = () => [
  {
    label: 'instagram',
    url: INSTAGRAM,
  },
  {
    label: 'youtube',
    url: YOUTUBE,
  },
  {
    label: 'linkedin',
    url: LINKEDIN,
  },
  {
    label: 'facebook',
    url: FACEBOOK,
  },
  {
    label: 'twitter',
    url: TWITTER,
  },
];

exports.getMainMenu = (locale, settingsUrl) => [[
  {
    url: `${process.env.infoUrl}/what`,
    key: 'how',
  }, {
    url: `${process.env.infoUrl}/about`,
    key: 'about',
  }, {
    url: `${process.env.infoUrl}/mobile`,
    key: 'mobileapp',
  }, {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  },
], [
  {
    url: GIFTING_TREES,
    key: 'giftingtrees',
  },
  {
    url: SHOP,
    key: 'shop',
  }, {
    url: getBlogURL(locale),
    key: 'blog',
  }, {
    url: JOBS,
    key: 'jobs',
  }, {
    url: FAQ,
    key: 'faq',
  },
], [
  {
    url: settingsUrl || '/settings',
    key: 'settings',
  },
]];
